import React                     from 'react'
import loadable                  from '@loadable/component';

/* Components */
const Home              = loadable(() => import('../Components/Home'));
const PaymentBook       = loadable(() => import('../Components/paymentBook'));

const AppRoutes = [
  {
    path:    "/",
    element: <Home />,
    type:    "public",
  },
  {
    path:    "/payment-book/:typeView/:idEmpleado",
    element: <PaymentBook />,
    type:    "public"
  }
];
export default AppRoutes;